import { useQuery as useGetCreditReportStatus } from "@faire/web-api/api/retailer/credit-report-status/get-hooks";
import { IRetailerCreditReportStatusResponse } from "@faire/web-api/indigofair/data/IRetailerCreditReportStatusResponse";
import { route as openWithFaireNMIRoute } from "@faire/web-api/routes/open-with-faire-additional-info";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";

import { useZustandLocation } from "@faire/retailer/app/_lib/routing/useZustandLocation";
import { useSettingOwFAutomatedCreditCheck } from "@faire/retailer/settings/useSettingOwFAutomatedCreditCheck";

export const useIsNMIApplication = () => {
  const { pathname } = useZustandLocation((state) => state.pathname);
  const isOwFAutomatedCreditCheck = useSettingOwFAutomatedCreditCheck();
  const { data, isLoading } = useGetCreditReportStatus();

  const isOnNMIRoute = pathMatchesRoute(pathname, openWithFaireNMIRoute);

  return {
    isLoadingCreditReportStatus: isLoading,
    isNMIApplication: isOnNMIRoute && isOwFAutomatedCreditCheck,
    hasNoCreditReport:
      data?.credit_report_status ===
      IRetailerCreditReportStatusResponse.RetailerCreditReportStatus.NO_REPORT,
    hasNoCreditScore:
      data?.credit_report_status ===
      IRetailerCreditReportStatusResponse.RetailerCreditReportStatus.NO_SCORE,
  };
};
